/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type JoinGiveawaySuccessResponse = {
    success: boolean;
    round: {
        /**
         * Updated participant count
         */
        participantCount: number;
        /**
         * Round status
         */
        status: JoinGiveawaySuccessResponse.status;
        /**
         * Updated end time (if status changed to ACTIVE)
         */
        endsAt?: string | null;
    };
};
export namespace JoinGiveawaySuccessResponse {
    /**
     * Round status
     */
    export enum status {
        '_0' = 0,
        '_10' = 10,
        '_20' = 20,
        '_30' = 30,
        '_40' = 40,
    }
}

